'use strict'

module.exports = class {

	show(title, elem, foot, onHide) {

		return new Promise(fulfill => {

			let container = document.querySelector('#optional')
			container.innerHTML = ''
			container.classList.remove('is-closed')

			container.appendChild(elem)

			let overlay = document.createElement('div')
			overlay.className = 'overlay'
			let content = document.createElement('div')
			content.className = 'content'
			content.innerHTML = `
				<div class="popup-title">
					<h1>` + title + `</h1>
					<button class="popup-close"><i class="material-icons">close</i></button>
				</div>
			`

			content.querySelector('.popup-close').onclick = () => {
				if (typeof onHide === 'function') { onHide() }
				else { this.hide() }
			}

			container.appendChild(overlay)
			container.appendChild(content)
			content.appendChild(elem)
			if (foot) { content.appendChild(foot) }

			fulfill(content)

		})
	}

	hide() {
		let container = document.querySelector('#optional')
		container.classList.add('is-closed')
		setTimeout(() => {
			container.innerHTML = ''
		}, 300)
	}

}



//////////////////
// WEBPACK FOOTER
// ./src/helpers/modal.js
// module id = 3
// module chunks = 0